import React from "react";
import { FormikProps } from "formik";

type FormikValues = Record<string, any>;

export const createDeferredValidationHandlers = <T extends FormikValues>(
	formik: FormikProps<T>,
	fieldName: keyof T & string,
) => {
	const handleChange = async (e: React.ChangeEvent<HTMLInputElement>) => {
		const value = e.target.value;
		if (formik.touched[fieldName]) {
			await formik.setFieldValue(fieldName, value, true);
			return;
		}
		await formik.setFieldValue(fieldName, value, false);
	};
	const handleBlur = async (e: React.FocusEvent<HTMLInputElement>) => {
		formik.handleBlur(e);
		await formik.validateField(fieldName);
	};
	const getError = () => {
		return formik.touched[fieldName] ? (formik.errors[fieldName] as string | undefined) : undefined;
	};

	return {
		handleChange,
		handleBlur,
		getError,
	};
};
